module.exports = __webpack_public_path__ + "img/Bedrock.7df1a77f.png";